import React, { useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import { Canvas3d } from './Dice3d.styles';
import { HEXtoBlackOrWhite } from '../../../services/colors';
import DicesController from './DicesController';

export default () => {

	const diceControler = useRef();
	const thrownDices = useRef();

	const zoom = useSelector(s => s.gridtoolsState.zoom);
	const center = useSelector(s => s.gridtoolsState.centerPoint);
	const messages = useSelector(state => state.chatState.messages);
	const use3dDices = useSelector(state => state.gridtoolsState.enable3dDices);
	
    useEffect(()=> {
		thrownDices.current = [];
	}, []);

    useEffect(()=> {
		if (use3dDices) {
			diceControler.current = new DicesController();
			const fn = diceControler.current.init();

			diceControler.current.setZoom(zoom);
			diceControler.current.setCenter(center);

			return fn;
		}

		return () => {};
    }, [use3dDices]);

    useEffect(()=> {
		if (zoom && diceControler.current) {
			diceControler.current.setZoom(zoom);
		}
    }, [zoom]);

    useEffect(()=> {
		if (diceControler.current) {
			diceControler.current.setCenter(center);
		}
    }, [center]);

    useEffect(()=> {
		const lastMessage = messages[messages.length - 1];
		if (!lastMessage) {
			return;
		}

		const color = lastMessage.color ?? '#ffffff';
		const font = HEXtoBlackOrWhite(color);

		const msgs = lastMessage.messages ?? [];
		const dicesArray = [];

		for (let m of msgs) {
			if (['roll','totalroll','silenttotalroll','silentroll', 'multiroll'].indexOf(m.command) >= 0) {
				if (!m.content || thrownDices.current.indexOf(m.id) >= 0) {
					continue;
				}

				thrownDices.current.push(m.id);

				let rolls = m.content.rolls ? [m.content.rolls] : m.content.map(a => a.rolls);
				for (let roll of rolls) {
					for (let d of roll) {
						dicesArray.push({
							numberOfDices: d.final.length || 1,
							diceType: d.sides,
							values: d.final
						});
					}
				}
			}
		}
		if (diceControler.current && dicesArray.length && use3dDices) {
			diceControler.current.addDice(color, font, dicesArray);
		}
    }, [messages, use3dDices]);


    return <Canvas3d id="dice3d" />
};